import { useId } from 'react';

export type CustomerStatus = 'normal' | 'vip' | 'flagged' | string | null | undefined;

type Props = {
  status?: CustomerStatus;
  vipLabel?: string | null | undefined;
  flaggedLabel?: string | null | undefined;
  reason?: string | null | undefined;
  size?: 'sm' | 'md';
  showTooltip?: boolean;
  className?: string;
};

export function CustomerStatusBadge({
  status,
  vipLabel = 'VIP',
  flaggedLabel = 'Flagged',
  reason,
  size = 'sm',
  showTooltip = true,
  className = '',
}: Props) {
  if (!status || status === 'normal') return null;

  const tipId = useId();
  const isVip = status === 'vip';
  const label = isVip ? vipLabel || 'VIP' : flaggedLabel || 'Flagged';
  const icon = isVip ? '⭐' : '⚠';
  const colors = isVip
    ? 'bg-amber-100 text-amber-900 border-amber-300'
    : 'bg-red-100 text-red-800 border-red-300';
  const sizing = size === 'md' ? 'px-2.5 py-1 text-sm' : 'px-1.5 py-0.5 text-xs';
  const title = showTooltip && reason ? reason : undefined;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md border font-semibold ${colors} ${sizing} ${className}`}
      title={title}
      aria-describedby={showTooltip && reason ? tipId : undefined}
    >
      <span aria-hidden>{icon}</span>
      <span>{label}</span>
      {showTooltip && reason ? (
        <span id={tipId} className="sr-only">
          {reason}
        </span>
      ) : null}
    </span>
  );
}
